"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutocompleteMobile = void 0;
var _react = _interopRequireDefault(require("react"));
var _OptionList = require("./OptionList.mobile");
// Components:

// Interface:

var AutocompleteMobile = exports.AutocompleteMobile = function AutocompleteMobile(_ref) {
  var autocompleteOptions = _ref.autocompleteOptions,
    onChoose = _ref.onChoose;
  var countries = autocompleteOptions.filter(function (opt) {
    return opt.kind.toLowerCase() === 'country';
  });
  var cities = autocompleteOptions.filter(function (opt) {
    return opt.kind.toLowerCase() === 'city';
  });
  var hotels = autocompleteOptions.filter(function (opt) {
    return opt.kind.toLowerCase() === 'hotel';
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, countries.length ? /*#__PURE__*/_react["default"].createElement(_OptionList.OptionListMobile, {
    label: "\u0421\u0442\u0440\u0430\u043D\u0430",
    countries: countries,
    onClickDestination: onChoose
  }) : null, cities.length ? /*#__PURE__*/_react["default"].createElement(_OptionList.OptionListMobile, {
    label: "\u041A\u0443\u0440\u043E\u0440\u0442\u044B",
    countries: cities,
    onClickDestination: onChoose
  }) : null, hotels.length ? /*#__PURE__*/_react["default"].createElement(_OptionList.OptionListMobile, {
    label: "\u041E\u0442\u0435\u043B\u0438",
    countries: hotels,
    onClickDestination: onChoose
  }) : null);
};